// extracted by mini-css-extract-plugin
module.exports = {"content":"AuthorizeToLogin_content__2hWHH","sendOtp":"AuthorizeToLogin_sendOtp__ny15W"};